import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1)
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = { class: "DialogSection" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1)
const _hoisted_8 = {
  class: "DialogSection",
  style: {"justify-content":"flex-end","gap":"1em","padding":"0.5em"}
}
const _hoisted_9 = {
  id: "D_Profiles_Print",
  class: "DialogSection"
}
const _hoisted_10 = { class: "JustPrint" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_14 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CookiesNormalInput, {
              Placeholder: _ctx.Translate('Profile Name'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Profile_Name') && _ctx.MEMRead('D_Profile_Name') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Profile_Name') && _ctx.MEMRead('D_Profile_Name') !== ''),
              Res: 'D_Profile_Name',
              Default: ''
            }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_CookiesDescriptionBox, {
              CustomStyle: 'min-height: 3em;',
              Placeholder: _ctx.Translate('Description'),
              Res: 'D_Profiles_Description'
            }, null, 8, ["Placeholder"])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CookiesIcon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.PrintTable())),
              ID: ('Printer' as IconsIDs),
              class: "SQR2em HoverUp",
              ToolTip: _ctx.Translate('Print')
            }, null, 8, ["ToolTip"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", null, _toDisplayString(_ctx.MEMRead('D_Profile_Name') + ' Roles'), 1),
              _hoisted_12
            ]),
            (!_ctx.DialogData.Data || (!_ctx.DialogData.Data.ID && !_ctx.DialogData.Data.ClonedID) || _ctx.OriginalData.Roles)
              ? (_openBlock(), _createBlock(_component_CookiesTable, {
                  key: 0,
                  class: "Shadow1",
                  CookiesInvalidInput: !(_ctx.MEMRead('D_Profiles_Roles_Table') && _ctx.MEMRead('D_Profiles_Roles_Table').length > 0),
                  ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Profiles_Roles_Table') && _ctx.MEMRead('D_Profiles_Roles_Table').length > 0),
                  TableSettings: _ctx.TableSettings,
                  CookiesData: _ctx.Roles,
                  Search: '',
                  Loading: _ctx.Loading.length
                }, null, 8, ["CookiesInvalidInput", "ErrorData", "TableSettings", "CookiesData", "Loading"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access(_ctx.DialogData.Editing ? 'Security_Profiles_Edit': 'Security_Profiles_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Save')), 5)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}